module.exports = __webpack_public_path__ + "img/icon9.3307a21f.jpg";